<template>
  <div class="container text-center">
    <form class="form-signin" @submit.prevent="submit">
      <img :src="require('@/assets/images/icon.png')" alt="icon" id="icon">
      <h1 class="h3 mb-3 font-weight-normal">Please sign in</h1>
      <label for="email" class="sr-only">Email address</label>
      <input type="email" id="email" class="form-control" placeholder="E-mail address" name="email" required autofocus v-model="form.email">
      <label for="password" class="sr-only">Password</label>
      <input type="password" id="password" class="form-control" placeholder="Password" name="password" required v-model="form.password">
      <button class="btn btn-lg btn-primary btn-block" type="submit" id="submit">Sign in</button>
    </form>
    <small class="errorBox">{{error}}</small>
    <p class="mt-5 mb-3 text-muted">Catalog Manager &copy; 2020</p>
  </div>
</template>

<script>
import firebase from "firebase/app";
import 'firebase/auth'

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      error: null
    };
  },
  methods: {
    submit() {
      firebase
        .auth()
        .signInWithEmailAndPassword(this.form.email, this.form.password)
        .catch(err => {
          this.error = err.message;
        });
    }
  }
};
</script>

<style scoped>
  html {
    min-height: 100%;
  }

  .errorBox {
    color: red
  }

  body {
    height: 100%;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: center;
    align-items: center;
    justify-content: center;
  }

  #icon {
    width: 250px;
    margin-bottom: 50px;
  }

  .form-signin {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
  .form-signin .checkbox {
    font-weight: 400;
  }
  .form-signin .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
  }
  .form-signin .form-control:focus {
    z-index: 2;
  }
  .form-signin input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .form-signin input[type="password"] {
    margin-bottom: 10px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
</style>